
/* convert to lowercase */
export const toLowerCase = (str) => {
    return str && str.toLowerCase()
}

export const debounce = (func, wait, immediate) => {
    let timeout
    return function () {
        const context = this; const args = arguments
        const later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

export const prettyUrl = (str) => {
    let newStr
    if (str.includes(',')) newStr = str.replace(',', '')
    else newStr = str

    return newStr.split(' ').join('-').toLowerCase()
}


export const camelToSentence = (str) => {
    const result = str.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult
}


export const numberWithCommas = (x) =>{
    if(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }else{
        return(0)
    }
    
}

export const errorParser = (response) => {
    // console.log('asda',response)
    var error =[] 
    if(response.data){
        if( response.data.errors ) {
            response.data.errors.map(text =>{
            if(text){
                error.push(text + " ")
               }
         })
        }else if(response.data.error ){
            error = response.data.error 
        }else{
            for (const [key, value] of Object.entries(response.data)) {
                console.log(value, key)
                if(value[0]){
                    error.push(key + ": " +value[0] + " ")
                }
            }
    
        }
    }else{
        if(response.error){
            error = response.error
        }
    }
 

    if(response.status == 404 ){
        error = "Can't Access Request API"
    }

    return error
}


